import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import {
  APP_INITIALIZER,
  Injector,
  NgModule,
  NO_ERRORS_SCHEMA,
  REQUEST,
  provideZoneChangeDetection,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, provideClientHydration, withNoIncrementalHydration } from '@angular/platform-browser';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgbModule, NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import * as Services from '@tgx/shared/services';
import { ToastsModule } from '@tgx/shared/toasts';
import { SharedLoggingModule } from '@tgx/shared/logging';
import { ComponentsModule } from '@tgx/shared/ui/components';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { StatusViewComponent } from './components/public/status-view/status-view.component';
import { V3SignUpActivateAccountComponent } from './components/public/v3-sign-up/v3-sign-up-register/v3-sign-up-activate-account/v3-sign-up-activate-account.component';
import { V3SignUpRegisterComponent } from './components/public/v3-sign-up/v3-sign-up-register/v3-sign-up-register.component';
import { V3SignUpUserFormComponent } from './components/public/v3-sign-up/v3-sign-up-register/v3-sign-up-user-form/v3-sign-up-user-form.component';
import { V3SignUpComponent } from './components/public/v3-sign-up/v3-sign-up.component';
import { XmlRedirectComponent } from './components/public/xml_redirect/xml-redirect.component';
import { CoreModuleWeb } from './core/web.core.module';
import { isPublicRoutePath } from './public-route-paths';
import { environment } from '../../../../environments/environment';
import { SharedUiStorybookModule } from '../../../../libs/shared/ui/storybook/src/lib/shared-ui-storybook.module';
import { OnboardingImplementationModule } from '@tgx/web/feature-onboarding-implementation';
import { OnboardingCompanyModule } from '@tgx/web/feature-onboarding-company';

export function initializeApp(injector: Injector) {
  return async (): Promise<any> => {
    const isPlatformBrowser = typeof window !== 'undefined';
    const req = isPlatformBrowser ? null : injector.get(REQUEST, null);
    const pathname = isPlatformBrowser ? window.location.pathname : req?.url || '';

    if (isPublicRoutePath(pathname)) {
      // Public route detected, skipping private authentication.
      return;
    }

    if (!isPlatformBrowser) {
      // Skipping browser auth flow during SSR.
      return;
    }
  };
}

@NgModule({
  declarations: [
    AppComponent,
    StatusViewComponent,
    XmlRedirectComponent,
    V3SignUpComponent,
    V3SignUpRegisterComponent,
    V3SignUpUserFormComponent,
    V3SignUpActivateAccountComponent,
  ],
  imports: [
    AppRoutingModule,
    CoreModuleWeb.forRoot(),
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    ToastsModule,
    SharedLoggingModule,
    ComponentsModule,
    OnboardingImplementationModule,
    OnboardingCompanyModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
    SharedUiStorybookModule,
  ],
  providers: [
    NgbTooltipConfig,
    Services.PlatformInfoService,
    Services.PlatformAuthService,
    Services.PlatformSelectorOrganizationService,
    Services.AuthService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [Injector],
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideZoneChangeDetection(),
    provideClientHydration(withNoIncrementalHydration()),
  ],
  schemas: [NO_ERRORS_SCHEMA],
  bootstrap: [AppComponent],
  exports: [AppComponent],
})
export class AppModule {}
